export const uniqueStringList = (list: string[]): string[] => {
    const uniqueListSet = new Set<string>();
    list.forEach((str) => {
        uniqueListSet.add(str);
    });

    return Array.from(uniqueListSet);
}
